import './SendEmailModal.scss';
import React from 'react';
import Button from '../../../buttons/DeprecatedButton/DeprecatedButton';
import happyMonkey from 'assets/monkey-happy.png';
import Input from '../../../components/Input/Input';
import { SessionObject } from '@mm/state/interfaces/session';
import { compose, withStateHandlers } from 'recompose';
import { StateUpdaterMethodTypes } from '@mm/utils';
import isEmail from 'validator/lib/isEmail';

type OuterProps = {
  sendEmail: Function;
  closeModal: Function;
  user: SessionObject;
};

type InitialState = ReturnType<typeof initialState>;
type StateUpdaters = StateUpdaterMethodTypes<
  InitialState,
  OuterProps,
  typeof stateUpdaters
>;

type InnerProps = InitialState & StateUpdaters;

type Props = OuterProps & InnerProps;

const SendEmailModal = ({
  sendEmail,
  user,
  email,
  downgradeHelp,
  setEmail,
  setDowngradeHelp,
  closeModal,
}: Props) => {
  return (
    <div className="send_email__modal">
      <div className="send_email__image-container">
        <img className="send_email__monkey-img" src={happyMonkey} />
      </div>
      <div className="send_email__body">
        <div className="send_email__title">That's great!</div>
        <div className="send_email__title">
          {' '}
          We can definitely work this out!
        </div>
        <div className="send_email__sub-title">
          Please briefly describe what we can help you with
        </div>
        <div className=" confirm-downgrade-modal__text send_email__text">
          <Input
            type="textarea"
            name="textarea-input"
            rows="3"
            value={downgradeHelp}
            onChange={e => setDowngradeHelp(e.target.value)}
          />
        </div>
        <div className="send_email__text">
          <Input
            type="text"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="send_email__info">
          We won't downgrade your page just yet. Our team will reach out ASAP
          using the information you've provided above.
        </div>
        <div className="send_email__buttons">
          <Button
            superDarkGray
            invert
            className="send_email__yes-button"
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            className="send_email__yes-button"
            superDarkGray
            disabled={!downgradeHelp.trim() || !email || !isEmail(email)}
            onClick={() => sendEmail(email, downgradeHelp)}
          >
            Cool!
          </Button>
        </div>
      </div>
    </div>
  );
};

const initialState = (props: OuterProps) => {
  const { user } = props;
  return {
    email: user.email,
    downgradeHelp: '',
  };
};

const stateUpdaters = {
  setEmail: () => email => ({ email }),
  setDowngradeHelp: () => downgradeHelp => ({ downgradeHelp }),
};

const enhance = compose<InnerProps, OuterProps>(
  withStateHandlers(initialState, stateUpdaters),
);

export default enhance(SendEmailModal);
